/* Collection filter accordion (mobile) and dropdown toggles (desktop) */
(function initCollectionFilterDropdowns() {
	const DESKTOP_QUERY = '(min-width: 1080px)';

	function closeDesktopDropdowns() {
		document
			.querySelectorAll('.filter-group--dropdown-open')
			.forEach((group) => {
				group.classList.remove('filter-group--dropdown-open');
				group.querySelectorAll('.js--filters__summary').forEach((trigger) => {
					trigger.setAttribute('aria-expanded', 'false');
				});
			});
	}

	function syncFilterTriggerExpandedState(group) {
		const triggers = group.querySelectorAll('.js--filters__summary');
		if (!triggers.length) return;

		const expanded = window.matchMedia(DESKTOP_QUERY).matches
			? group.classList.contains('filter-group--dropdown-open')
			: group.hasAttribute('open');
		const value = expanded ? 'true' : 'false';
		triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', value));
	}

	document.addEventListener('click', (event) => {
		const filtersToggle = event.target.closest(
			'.js--collection-filters-toggle',
		);

		if (
			filtersToggle &&
			filtersToggle.classList.contains('js--collection-filters-toggle') &&
			window.matchMedia(DESKTOP_QUERY).matches
		) {
			const wrapper = document.querySelector('.filters-sort__wrapper');
			if (wrapper) {
				const isVisible = wrapper.classList.toggle(
					'filters-sort__wrapper--filters-visible',
				);
				filtersToggle.setAttribute(
					'aria-expanded',
					isVisible ? 'true' : 'false',
				);
				filtersToggle.classList.toggle(
					'collection-filters-toggle--active',
					isVisible,
				);
				const grid = document.querySelector(
					'.collection-grid__container[data-collection-section-id]',
				);
				if (grid) {
					grid.classList.toggle(
						'collection-grid--filters-toolbar-open',
						isVisible,
					);
				}
				window.dispatchEvent(
					new CustomEvent('collection-filters:toolbar-toggle'),
				);

				if (!isVisible) {
					closeDesktopDropdowns();
				}
			}
			return;
		}

		const trigger = event.target.closest('.js--filters__summary');
		const filtersForm = document.querySelector('#FiltersForm');

		if (!filtersForm) return;

		if (trigger && filtersForm.contains(trigger)) {
			event.preventDefault();
			const group = trigger.closest('.js--filter');
			if (!group) return;

			if (window.matchMedia(DESKTOP_QUERY).matches) {
				const isOpen = group.classList.contains('filter-group--dropdown-open');
				closeDesktopDropdowns();
				if (!isOpen) {
					group.classList.add('filter-group--dropdown-open');
				}
				syncFilterTriggerExpandedState(group);
				return;
			}

			if (group.hasAttribute('open')) {
				group.removeAttribute('open');
			} else {
				group.setAttribute('open', '');
			}
			syncFilterTriggerExpandedState(group);
			return;
		}

		if (
			window.matchMedia(DESKTOP_QUERY).matches &&
			!event.target.closest('.js--filter')
		) {
			closeDesktopDropdowns();
		}
	});

	document.addEventListener('keyup', (event) => {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		if (window.matchMedia(DESKTOP_QUERY).matches) {
			closeDesktopDropdowns();
			return;
		}

		const group = event.target.closest('.js--filter[open]');
		if (!group) return;

		group.removeAttribute('open');
		syncFilterTriggerExpandedState(group);
		group
			.querySelector('.js--filters__summary.filters__summary-trigger--mobile')
			?.focus();
	});

	document
		.querySelectorAll('#FiltersForm .js--filter')
		.forEach(syncFilterTriggerExpandedState);
})();

(function initCollectionFiltersClearAll() {
	const CLEAR_WRAPPER_SELECTOR = '.collection-filters__clear-wrapper';
	const HIDDEN_CLASS = 'collection-filters__clear-wrapper--hidden';

	function hasActiveFilters(form) {
		if (
			form.querySelector(
				'input[type="checkbox"]:checked, input[type="radio"]:checked',
			)
		) {
			return true;
		}

		return Array.from(form.querySelectorAll('price-range input')).some(
			(input) => input.value.trim() !== '',
		);
	}

	function syncClearAllVisibility() {
		const form = document.querySelector('#FiltersForm');
		if (!form) return;

		const isActive = hasActiveFilters(form);

		document
			.querySelectorAll('[data-collection-filters-clear-all]')
			.forEach((link) => {
				link.toggleAttribute('hidden', !isActive);
			});

		document.querySelectorAll(CLEAR_WRAPPER_SELECTOR).forEach((wrapper) => {
			wrapper.classList.toggle(HIDDEN_CLASS, !isActive);
			wrapper.toggleAttribute('hidden', !isActive);
		});

		document
			.querySelectorAll('[data-collection-active-filters-bar]')
			.forEach((bar) => {
				bar.classList.toggle('collection-active-filters-bar--empty', !isActive);
			});

		document
			.querySelectorAll('[data-collection-active-filters-row]')
			.forEach((row) => {
				row.classList.toggle('collection-active-filters-row--empty', !isActive);
			});
	}

	window.__thymesSyncClearAllVisibility = syncClearAllVisibility;

	function onFiltersFormActivity(event) {
		if (!event.target.closest('#FiltersForm')) return;
		syncClearAllVisibility();
	}

	function init() {
		document.addEventListener('change', onFiltersFormActivity);
		document.addEventListener('input', onFiltersFormActivity);

		syncClearAllVisibility();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();

(function initCollectionFilterPillsAndMobileClear() {
	const DESKTOP_MQ = '(min-width: 1080px)';

	function getPillsMountDesktop() {
		return document.getElementById('CollectionActiveFilterPills');
	}

	function mergeSortIntoParams(params) {
		const sortSelect =
			document.querySelector('#SortForm select[name="sort_by"]') ||
			document.querySelector('#SortBy') ||
			document.querySelector('select[name="sort_by"]');
		if (sortSelect && sortSelect.name) {
			params.set(sortSelect.name, sortSelect.value);
		}
	}

	function paramsFromFilterForm(form) {
		const p = new URLSearchParams();
		const fd = new FormData(form);
		for (const [k, v] of fd.entries()) {
			if (v === '' || v == null) continue;
			p.append(k, v);
		}
		mergeSortIntoParams(p);
		return p;
	}

	function removeFilterParamOnce(sourceParams, paramName, paramValue) {
		const next = new URLSearchParams();
		let skipped = false;
		for (const [k, v] of sourceParams.entries()) {
			if (!skipped && k === paramName && String(v) === String(paramValue)) {
				skipped = true;
				continue;
			}
			next.append(k, v);
		}
		return next;
	}

	function buildFilterPills(form) {
		const baseUrl = new URL(window.location.href);
		const fullParams = paramsFromFilterForm(form);
		const pills = [];

		form
			.querySelectorAll(
				'input[type="checkbox"]:checked, input[type="radio"]:checked',
			)
			.forEach((input) => {
				if (!input.name) return;
				const minus = removeFilterParamOnce(
					new URLSearchParams(fullParams),
					input.name,
					input.value,
				);
				const label =
					input.getAttribute('data-pill-label') || input.value || '';
				pills.push({
					label,
					href: `${baseUrl.pathname}?${minus.toString()}`,
				});
			});

		form.querySelectorAll('price-range').forEach((pr) => {
			const inputs = Array.from(
				pr.querySelectorAll('input[type="number"]'),
			).filter((el) => el.name && String(el.value || '').trim() !== '');
			if (!inputs.length) return;
			const minus = new URLSearchParams(fullParams);
			inputs.forEach((el) => {
				minus.delete(el.name);
			});
			const label = pr.getAttribute('data-pill-label') || '';
			pills.push({
				label,
				href: `${baseUrl.pathname}?${minus.toString()}`,
			});
		});

		return pills;
	}

	function renderPillsToMount(mount, pills) {
		if (!mount) return;

		const nextKey = pills
			.map(({ label, href }) => `${label}\u0000${href}`)
			.join('\u0001');
		if (mount.dataset.pillsKey === nextKey) return;
		mount.dataset.pillsKey = nextKey;

		mount.replaceChildren();
		pills.forEach(({ label, href }) => {
			const li = document.createElement('li');
			li.setAttribute('role', 'listitem');
			const a = document.createElement('a');
			a.className = 'collection-active-filter-pill';
			a.href = href;
			const text = document.createElement('span');
			text.className = 'collection-active-filter-pill__text';
			text.textContent = label;
			const removeMark = document.createElement('span');
			removeMark.className = 'collection-active-filter-pill__remove';
			removeMark.setAttribute('aria-hidden', 'true');
			removeMark.textContent = '\u00d7';
			a.appendChild(text);
			a.appendChild(removeMark);
			li.appendChild(a);
			mount.appendChild(li);
		});
	}

	function syncFilterGroupSelectedCounts() {
		const form = document.querySelector('#FiltersForm');
		if (!form) return;

		form.querySelectorAll('.js--filter').forEach((group) => {
			const checkedCount = group.querySelectorAll(
				'input[type="checkbox"]:checked, input[type="radio"]:checked',
			).length;
			const hasPrice = Array.from(
				group.querySelectorAll('input[type="number"]'),
			).some((el) => String(el.value || '').trim() !== '');
			const count = checkedCount > 0 ? checkedCount : hasPrice ? 1 : 0;

			group.querySelectorAll('.js--filters__selected').forEach((span) => {
				const nextText = count > 0 ? `(${count})` : '(0)';
				const shouldHide = count === 0;

				if (span.textContent !== nextText) {
					span.textContent = nextText;
				}
				if (shouldHide && !span.classList.contains('hidden')) {
					span.classList.add('hidden');
				} else if (!shouldHide && span.classList.contains('hidden')) {
					span.classList.remove('hidden');
				}
			});
		});
	}

	function syncCollectionFilterPills() {
		const form = document.querySelector('#FiltersForm');
		if (!form) return;

		const pills = buildFilterPills(form);
		const isDesktop = window.matchMedia(DESKTOP_MQ).matches;

		if (isDesktop) {
			const mount = getPillsMountDesktop();
			const grid = document.querySelector(
				'.collection-grid__container[data-filter-display]',
			);
			const displayMode = grid?.dataset?.filterDisplay || '';
			const compactToolbarOpen = Boolean(
				grid?.classList.contains('collection-grid--filters-toolbar-open'),
			);

			if (displayMode === 'compact_toggle' && !compactToolbarOpen) {
				renderPillsToMount(mount, []);
			} else {
				renderPillsToMount(mount, pills);
			}

			renderPillsToMount(
				document.getElementById('CollectionActiveFilterPillsMobilePage'),
				[],
			);
			renderPillsToMount(
				document.getElementById('CollectionActiveFilterPillsMobileModal'),
				[],
			);
		} else {
			renderPillsToMount(getPillsMountDesktop(), []);
			renderPillsToMount(
				document.getElementById('CollectionActiveFilterPillsMobilePage'),
				pills,
			);
			renderPillsToMount(
				document.getElementById('CollectionActiveFilterPillsMobileModal'),
				pills,
			);
		}
	}

	function syncAll() {
		syncFilterGroupSelectedCounts();
		syncCollectionFilterPills();
		window.__thymesSyncClearAllVisibility?.();
	}

	window.__thymesCollectionFiltersSyncUi = syncAll;

	function onFilterFormActivity(event) {
		if (event.target.closest('#FiltersForm')) {
			syncAll();
		}
	}

	function onSortFormChange(event) {
		const sel = event.target.closest(
			'#SortForm select[name="sort_by"], #SortFormMobile select[name="sort_by"]',
		);
		if (sel) {
			syncAll();
		}
	}

	function attachFilterFetchSyncObservers() {
		document.querySelectorAll('#ProductCount').forEach((el) => {
			if (el.dataset.thymesFetchObserved === 'true') return;
			el.dataset.thymesFetchObserved = 'true';

			const observer = new MutationObserver((mutations) => {
				for (const mutation of mutations) {
					if (mutation.attributeName !== 'class') continue;
					if (!mutation.target.classList.contains('loading')) {
						syncAll();
						break;
					}
				}
			});
			observer.observe(el, { attributes: true, attributeFilter: ['class'] });
		});
	}

	function init() {
		document.addEventListener('change', onFilterFormActivity);
		document.addEventListener('input', onFilterFormActivity);
		document.addEventListener('change', onSortFormChange);
		document.addEventListener('collection-filters:toolbar-toggle', syncAll);

		window.addEventListener('popstate', syncAll);
		document.addEventListener('shopify:section:load', () => {
			attachFilterFetchSyncObservers();
			syncAll();
		});

		attachFilterFetchSyncObservers();

		try {
			window.matchMedia(DESKTOP_MQ).addEventListener('change', syncAll);
		} catch (e) {
			window.matchMedia(DESKTOP_MQ).addListener(syncAll);
		}

		syncAll();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();

/* Mobile collection filter drawer slide animation */
(function initCollectionFilterDrawerAnimation() {
	const MOBILE_QUERY = '(max-width: 1079px)';
	const MODAL_SELECTOR = '.collection-filters-sort-modal';
	const OPEN_CLASS = 'modal--open';
	const CLOSING_CLASS = 'collection-filters-sort-modal--closing';
	const NO_SCROLL_CLASS = 'noscroll';
	const DRAWER_DURATION_MS = 220;

	function isMobileDrawerContext() {
		return window.matchMedia(MOBILE_QUERY).matches;
	}

	function getOpenDrawerModal() {
		return document.querySelector(`${MODAL_SELECTOR}.${OPEN_CLASS}`);
	}

	function finalizeDrawerClose(modal) {
		modal.classList.remove(CLOSING_CLASS);
		modal.querySelectorAll('[tabindex="0"]').forEach((element) => {
			element.setAttribute('tabindex', '-1');
		});
		document.body.classList.remove(NO_SCROLL_CLASS);
		const targetId = modal.id.replace('modal_', '');
		const trigger = document.querySelector(`[data-modal-target="${targetId}"]`);
		trigger?.focus();
		window.dispatchEvent(new CustomEvent('close.modal', { detail: modal }));
	}

	function closeCollectionFilterDrawer(modal) {
		if (!modal || modal.classList.contains(CLOSING_CLASS)) return;

		modal.classList.add(CLOSING_CLASS);
		modal.classList.remove(OPEN_CLASS);
		window.setTimeout(() => finalizeDrawerClose(modal), DRAWER_DURATION_MS);
	}

	document.addEventListener(
		'click',
		(event) => {
			if (!isMobileDrawerContext()) return;

			const closeTarget = event.target.closest(
				`${MODAL_SELECTOR} .modal__close-button, ${MODAL_SELECTOR} .modal__overlay`,
			);
			if (!closeTarget) return;

			const modal = closeTarget.closest(MODAL_SELECTOR);
			if (!modal?.classList.contains(OPEN_CLASS)) return;

			event.preventDefault();
			event.stopImmediatePropagation();
			closeCollectionFilterDrawer(modal);
		},
		true,
	);

	document.addEventListener(
		'keydown',
		(event) => {
			if (event.key !== 'Escape' || !isMobileDrawerContext()) return;

			const modal = getOpenDrawerModal();
			if (!modal) return;

			event.preventDefault();
			event.stopImmediatePropagation();
			closeCollectionFilterDrawer(modal);
		},
		true,
	);

	function collapseMobileFilterGroups() {
		if (!isMobileDrawerContext()) return;

		document
			.querySelectorAll('#FiltersForm .js--filter[open]')
			.forEach((group) => {
				group.removeAttribute('open');
				group.querySelectorAll('.js--filters__summary').forEach((trigger) => {
					trigger.setAttribute('aria-expanded', 'false');
				});
			});
	}

	document.addEventListener(
		'click',
		(event) => {
			if (!isMobileDrawerContext()) return;

			const trigger = event.target.closest(
				'.filters-sort-trigger.modal__trigger[data-modal-target^="filters-sort-"]',
			);
			if (!trigger) return;

			const targetId = trigger.getAttribute('data-modal-target');
			if (!targetId) return;

			const modal = document.getElementById('modal_' + targetId);
			if (!modal?.classList.contains('collection-filters-sort-modal')) return;

			if (
				modal.classList.contains(OPEN_CLASS) ||
				modal.classList.contains(CLOSING_CLASS)
			) {
				return;
			}

			event.preventDefault();
			collapseMobileFilterGroups();
			document.body.classList.add(NO_SCROLL_CLASS);
			modal.classList.add(OPEN_CLASS);
			window.__thymesCollectionFiltersSyncUi?.();
		},
		false,
	);

	window.__thymesCloseCollectionFilterDrawer = closeCollectionFilterDrawer;
})();

(function initCollectionFilterSectionFetch() {
	function getCollectionSectionId() {
		return document.querySelector(
			'.collection-grid__container[data-collection-section-id]',
		)?.dataset?.collectionSectionId;
	}

	function isInCollectionGrid(anchor) {
		return Boolean(
			anchor.closest('.collection-grid__container[data-collection-section-id]'),
		);
	}

	function resyncFilterGroupAriaAfterSectionSwap() {
		const DESKTOP_QUERY = '(min-width: 1080px)';
		document.querySelectorAll('#FiltersForm .js--filter').forEach((group) => {
			const triggers = group.querySelectorAll('.js--filters__summary');
			if (!triggers.length) return;
			const expanded = window.matchMedia(DESKTOP_QUERY).matches
				? group.classList.contains('filter-group--dropdown-open')
				: group.hasAttribute('open');
			const value = expanded ? 'true' : 'false';
			triggers.forEach((trigger) =>
				trigger.setAttribute('aria-expanded', value),
			);
		});
	}

	function fetchCollectionSectionHtml(href, sectionId) {
		const target = new URL(href, window.location.origin);
		if (target.origin !== window.location.origin) {
			return Promise.reject(new Error('origin'));
		}
		const fetchUrl = new URL(target.href);
		fetchUrl.searchParams.set('sections', sectionId);
		return fetch(fetchUrl.toString())
			.then((res) => {
				if (!res.ok) throw new Error(String(res.status));
				return res.json();
			})
			.then((data) => {
				const html = data[sectionId];
				if (!html || typeof html !== 'string') {
					throw new Error('missing section html');
				}
				const displayUrl = new URL(target.href);
				displayUrl.searchParams.delete('sections');
				return { html, displayUrl };
			});
	}

	function getParsedSectionRoot(html, sectionId) {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		return (
			doc.getElementById('shopify-section-' + sectionId) ||
			doc.querySelector('.shopify-section') ||
			doc.body
		);
	}

	function replaceFromIncomingRoot(incomingRoot, selector) {
		const incoming = incomingRoot.querySelector(selector);
		const cur = document.querySelector(selector);
		if (incoming && cur) {
			cur.replaceWith(document.importNode(incoming, true));
			return true;
		}
		return false;
	}

	function replaceFiltersFormWrapper(incomingRoot, formSelector) {
		const currentForm = document.querySelector(formSelector);
		const incomingForm = incomingRoot.querySelector(formSelector);
		if (!currentForm || !incomingForm) return false;

		const currentWrapper = currentForm.closest('filters-form');
		const incomingWrapper = incomingForm.closest('filters-form');
		if (!currentWrapper || !incomingWrapper) return false;

		currentWrapper.replaceWith(document.importNode(incomingWrapper, true));
		return true;
	}

	function syncProductCountsFromIncomingSection(incomingRoot, sectionId) {
		const sectionMount = document.getElementById(
			'shopify-section-' + sectionId,
		);
		if (!sectionMount) return;

		const incomingCounts = incomingRoot.querySelectorAll('.product-count');
		const currentCounts = sectionMount.querySelectorAll('.product-count');
		const len = Math.min(incomingCounts.length, currentCounts.length);
		for (let i = 0; i < len; i++) {
			currentCounts[i].replaceWith(
				document.importNode(incomingCounts[i], true),
			);
		}
	}

	function afterCollectionDomUpdate(sectionId, displayUrl) {
		history.pushState(
			{},
			'',
			displayUrl.pathname + displayUrl.search + displayUrl.hash,
		);

		window.__thymesCollectionFiltersSyncUi?.();
		window.__thymesSyncClearAllVisibility?.();

		document
			.getElementById('shopify-section-' + sectionId)
			?.dispatchEvent(
				new CustomEvent('shopify:section:load', {
					bubbles: true,
					detail: { sectionId: sectionId },
				}),
			);

		resyncFilterGroupAriaAfterSectionSwap();
	}

	function applyPartialCollectionFilterUpdate(
		html,
		sectionId,
		displayUrl,
		options,
	) {
		const preserveMobileDrawer = Boolean(
			options && options.preserveMobileDrawer,
		);
		const incomingRoot = getParsedSectionRoot(html, sectionId);

		replaceFromIncomingRoot(incomingRoot, '#ProductGridContainer');
		replaceFiltersFormWrapper(incomingRoot, '#FiltersForm');
		replaceFiltersFormWrapper(incomingRoot, '#SortForm');
		replaceFiltersFormWrapper(incomingRoot, '#SortFormMobile');
		replaceFromIncomingRoot(
			incomingRoot,
			'[data-collection-active-filters-row]',
		);

		const incomingBars = incomingRoot.querySelectorAll(
			'[data-collection-active-filters-bar]',
		);
		const currentBars = document.querySelectorAll(
			'[data-collection-active-filters-bar]',
		);
		incomingBars.forEach((incomingBar, index) => {
			const currentBar = currentBars[index];
			if (currentBar) {
				currentBar.replaceWith(document.importNode(incomingBar, true));
			}
		});

		syncProductCountsFromIncomingSection(incomingRoot, sectionId);

		afterCollectionDomUpdate(sectionId, displayUrl);

		if (preserveMobileDrawer) {
			const modal = document.querySelector('.collection-filters-sort-modal');
			if (modal) {
				modal.classList.remove('collection-filters-sort-modal--closing');
				modal.classList.add('modal--open');
				document.body.classList.add('noscroll');
			}
		}
	}

	function applyPartialFilterNavigation(href, options) {
		const sectionId = getCollectionSectionId();
		if (!sectionId) {
			window.location.assign(href);
			return;
		}

		fetchCollectionSectionHtml(href, sectionId)
			.then(({ html, displayUrl }) => {
				applyPartialCollectionFilterUpdate(
					html,
					sectionId,
					displayUrl,
					options,
				);
			})
			.catch(() => {
				window.location.assign(href);
			});
	}

	function applyCollectionFilterNavigation(href) {
		const sectionId = getCollectionSectionId();

		if (!sectionId) {
			window.location.assign(href);
			return;
		}

		fetchCollectionSectionHtml(href, sectionId)
			.then(({ html, displayUrl }) => {
				const mountId = 'shopify-section-' + sectionId;
				const current = document.getElementById(mountId);
				if (!current) {
					throw new Error('missing section mount');
				}

				const gridBefore = current.querySelector(
					'.collection-grid__container[data-filter-display]',
				);
				const wasCompactToolbarOpen =
					gridBefore?.dataset.filterDisplay === 'compact_toggle' &&
					gridBefore.classList.contains(
						'collection-grid--filters-toolbar-open',
					);

				current.outerHTML = html.trim();

				if (wasCompactToolbarOpen) {
					const sectionRoot = document.getElementById(mountId);
					const newGrid = sectionRoot?.querySelector(
						'.collection-grid__container[data-filter-display]',
					);
					if (newGrid?.dataset.filterDisplay === 'compact_toggle') {
						newGrid.classList.add('collection-grid--filters-toolbar-open');
						document
							.querySelector('.filters-sort__wrapper')
							?.classList.add('filters-sort__wrapper--filters-visible');
						const toggle = document.querySelector(
							'.js--collection-filters-toggle',
						);
						if (toggle) {
							toggle.setAttribute('aria-expanded', 'true');
							toggle.classList.add('collection-filters-toggle--active');
						}
					}
				}

				afterCollectionDomUpdate(sectionId, displayUrl);
			})
			.catch(() => {
				window.location.assign(href);
			});
	}

	document.addEventListener(
		'click',
		(event) => {
			const anchor = event.target.closest('a');
			if (!anchor || !anchor.href) return;

			const isPill = anchor.classList.contains('collection-active-filter-pill');
			const isGroupClear = anchor.classList.contains(
				'filter-group__clear--mobile-drawer',
			);
			const isClearAll =
				anchor.classList.contains('collection-filters__clear') ||
				anchor.hasAttribute('data-collection-filters-clear-all');
			if (!isPill && !isGroupClear && !isClearAll) return;

			if (!isInCollectionGrid(anchor)) return;

			event.preventDefault();

			const isMobile = window.matchMedia('(max-width: 1079px)').matches;
			const preserveMobileDrawer =
				isMobile && Boolean(anchor.closest('.collection-filters-sort-modal'));

			if (isMobile && (isPill || isGroupClear || isClearAll)) {
				applyPartialFilterNavigation(anchor.href, { preserveMobileDrawer });
				return;
			}

			applyCollectionFilterNavigation(anchor.href);
		},
		true,
	);
})();
